import React from 'react';
import cx from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';
import { ContentSection, ContentSectionProps } from 'Storybook/components/local/ContentSection';

import { usePageRefEvents } from '../../Pages/CheckerRouter.utils';
import { ContentImage } from '../ContentImage/ContentImage';

import styles from './CheckerContentBlocks.scss';

type CheckerContentBlockProps = {
  contentData: ContentSectionProps[];
  onLoad: (label: string) => void;
};

export const CheckerContentBlocks = ({ contentData, onLoad }: CheckerContentBlockProps) => {
  const sectionTitles = contentData.map((content) => content.title);

  const {
    $wrapper,
    entryMap: eventMap,
    setRef: setContentBlockRef,
  } = usePageRefEvents({
    eventLabels: sectionTitles,
    onRefTrigger: (label?: string) => onLoad(label ?? ''),
  });

  const setBlockRef = <T extends Element>(ref: T, index: number) => {
    const entry = eventMap.get(sectionTitles[index]);
    if (!entry?.isIntersecting) {
      setContentBlockRef(ref, index);
    }
  };

  return (
    <div ref={$wrapper} className={styles.component}>
      <Content className={styles.wrapper}>
        {contentData.map((content, index) => {
          const { imgAlt, imgSrc, ...contentDetails } = content;
          return (
            <div
              key={sectionTitles[index] || index}
              ref={(ref) => {
                if (ref) {
                  setBlockRef(ref, index);
                }
              }}
              className={cx({ [styles.topCard]: index === 0 })}
              data-testid='content-section'
            >
              <ContentSection
                {...contentDetails}
                imgSrc={<ContentImage {...{ imgAlt }} imgSrc={imgSrc as string} />}
                reverse={ index % 2 === 0 }
              />
            </div>
          );
        })}
      </Content>
    </div>
  );
};
